// extracted by mini-css-extract-plugin
module.exports = {"canvas":"_1Agd7Bj","action":"_1CTyepx"};